import dayjs from 'dayjs';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { RightAngleIcon } from '../../../../components/Icons/RightAngle';
import { SeparatorLine } from '../../../../components/SeparatorLine/SeparatorLine';
import { Config } from '../../../../helpers/config';
import { extractRange } from '../../../../helpers/dateTimes';
import { useLanguage } from '../../../../locale/useLanguage';
import { Order, Product } from '../../../../models';
import { Routes } from '../../../../routes/types';

import './TransactionList.css';

type TransactionListProps = {
  order: Order;
};

export const TransactionList: React.FC<TransactionListProps> = ({ order }) => {
  const [t] = useLanguage();
  const history = useHistory();

  const goToTransactionDetails = useCallback(
    (transactionId: string) => {
      return () =>
        history.push(
          Routes.TransactionDetails.replace(
            ':transactionId',
            transactionId
          ).replace(':orderId', `${order.id}`)
        );
    },
    [history, order.id]
  );

  return (
    <>
      {order.purchaseItems?.map((transaction) => {
        const isPdr = transaction.product === Product.Pdr;
        const title = isPdr
          ? t('chooseTransaction.pickUpPoint')
          : t('chooseTransaction.appointment');

        const secondLineDescription = isPdr
          ? t('chooseTransaction.pickUpPointName')
          : t('chooseTransaction.date');

        const thirdLineDescription = isPdr
          ? t('chooseTransaction.pickUpPointAddress')
          : t('chooseTransaction.timeRange');

        // TODO: When appointment booking configurations is developed change empty strings
        let firstValue: string;
        let secondValue: string;

        if (!isPdr) {
          const timeRange = extractRange(transaction.configuration.timeRange);
          firstValue = timeRange.from.format('DD MMMM YYYY');
        } else {
          firstValue = transaction.configuration.pdr!.name;
        }

        if (!isPdr) {
          const timeRange = extractRange(transaction.configuration.timeRange);
          secondValue = `${timeRange.from.format(
            'HH:mm'
          )} - ${timeRange.to.format('HH:mm')}`;
        } else {
          secondValue = transaction.configuration.pdr!.indirizzo;
        }

        const now = dayjs();
        const created = dayjs(transaction.createdAt);
        if (now.diff(created, 'hours') > 6 && transaction.status === 'NEW') {
          return <></>;
        } else {
          return (
            <React.Fragment key={transaction.id}>
              <a
                role="link"
                onClick={goToTransactionDetails(`${transaction.purchaseId}`)}
                className="transaction-list--element-container"
              >
                <div className="transaction-list--element-details">
                  <h3 className="transaction-list--element-title">{title}</h3>
                  <p className="transaction-list--element-description">
                    {secondLineDescription}: {firstValue}
                  </p>
                  <p className="transaction-list--element-description">
                    {thirdLineDescription}: {secondValue}
                  </p>
                </div>
                <div className="transaction-list--angle-container">
                  <RightAngleIcon
                    color={Config.secondaryText}
                    width={12}
                    height={12}
                  />
                </div>
              </a>
              <SeparatorLine />
            </React.Fragment>
          );
        }
      })}
    </>
  );
};
